import React, { useEffect } from "react";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import RelatedWorks from "./RelatedWorks";
import "./Mgrdetail.css";

export default function AtssDetails() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="work-detail-page">
      <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', zIndex: 1000 }}>
        <Navbar />
      </div>

      <section className="project-info-section">
        <h1 className="project-title-heading">
          ATSS Technologies
        </h1>

        <p className="project-description">
        We partnered with ATSS Technologies to create professional marketing and business communication materials that strengthen their brand presence. Through a thoughtfully designed product brochure and corporate visiting card system, we helped communicate their security, surveillance, and automation solutions with clarity, consistency, and professionalism.
        </p>


        <div className="project-tags">
          <span className="info-tag">Brochure Design</span>
          <span className="info-tag">Visiting Card Design</span>
          <span className="info-tag">Brand Communication</span>
          <span className="info-tag">Print Design</span>
          <span className="info-tag">Corporate Identity</span>
        </div>
      </section>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Atss/Full1.webp" 
          alt="ATSS Smart Automation Mockup" 
        />
      </div>
      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Atss/Full2.webp" 
          alt="ATSS Surveillance Tech Mockup" 
        />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
        "We designed a professional product brochure for ATSS Technologies to effectively showcase their security, surveillance, and home automation solutions. The layout combines clear information hierarchy, engaging visuals, and structured content to communicate complex services in a simple and accessible format. The brochure serves as a powerful marketing tool that strengthens brand credibility and helps customers understand the company's complete range of technology solutions."
        </div>
      </section>

      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Atss/Full3.webp" 
          alt="ATSS Interface Design" 
        />
      </div>
      <div className="project-full-image-section">
        <img 
          src="https://ascentbw.com/Images/Atss/Full4.webp" 
          alt="ATSS Digital Deployment" 
        />
      </div>

      <section className="project-quote-section">
        <div className="quote-text right-aligned">
         "We designed a professional and modern business card system for ATSS Technologies that reflects the brand's expertise in security, surveillance, and automation solutions. The design combines clean layouts, strong visual hierarchy, and consistent brand elements to create a memorable first impression while reinforcing trust and professionalism during client interactions."
        </div>
      </section>

      <RelatedWorks excludePath="/works/atss" />
      <Footer />
    </div>
  );
}
